export { default } from '@/features/jobs/components/advanced/AdvancedFilterComponent';
